<div class="container flex column justify-flex-start align-center">
  <img class="image" [src]="imagePath" />
  <span class="h3">{{title}}</span>
  <p class="mt-2 mb-4 text-normal" [innerHTML]="message"></p>
  <button *ngIf="showButton" mat-raised-button app-click-stop-propagation color="color-on-error" class="button" [routerLink]="[buttonUrl]">
    {{buttonText}}
  </button>
</div>
